import { Box, Skeleton, Typography } from "@mui/material";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { useMemo } from "react";

interface SparklineProps {
  data: (number | null)[];
  isLoading?: boolean;
  width?: number;
  height?: number;
  color?: string;
}

const Sparkline = ({
  data,
  isLoading = false,
  width = 120,
  height = 30,
  color = "#1976d2"
}: SparklineProps) => {
  const sparklineData = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }

    return data.filter(d => d !== null && d !== undefined) as number[];
  }, [data]);

  if (isLoading) {
    return <Skeleton variant="rectangular" width={width} height={height} />;
  }

  if (!data || data.length === 0 || sparklineData.length === 0) {
    return (
      <Box sx={{ width, height, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Typography variant="caption" color="text.disabled">
          No data
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width, height }}>
      <SparkLineChart
        data={sparklineData}
        width={width}
        height={height}
        margin={{ top: 2, bottom: 2, left: 2, right: 2 }}
        slotProps={{
          line: { style: { stroke: color } }
        }}
      />
    </Box>
  );
};

export default Sparkline;
